import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect to the default builder (canvas)
export const Route = createFileRoute('/_dashboard/agents/create/')({
  beforeLoad: () => {
    throw redirect({ to: '/agents/create/canvas' });
  },
  component: () => null,
});
